/* ---------------------------
 * cart-notification.js
 * Handles remove buttons, animations, and cart updates
 * ---------------------------
 */

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', async (event) => {
      event.preventDefault();

      const cartDrawer = document.querySelector('cart-drawer');
      const cartItemsContainer =
        this.closest('cart-items') ||
        this.closest('cart-drawer-items') ||
        document.querySelector('cart-items') ||
        document.querySelector('cart-drawer-items');

      if (!cartItemsContainer) {
        console.error('Cart container not found.');
        return;
      }

      const line = parseInt(this.dataset.index, 10);
      const cartItemElement = this.closest('.cart-item') || this.closest('.drawer__item');

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({ line, quantity: 0 }),
        });

        const data = await response.json();

        // Fade out animation
        if (cartItemElement) {
          cartItemElement.style.transition = 'opacity 0.3s ease';
          cartItemElement.style.opacity = 0;
          setTimeout(() => cartItemElement.remove(), 300);
        }

        // Refresh cart drawer contents but keep the close button intact
        if (cartDrawer?.renderContents) {
          const closeButton = cartDrawer.querySelector('.drawer__close');
          await cartDrawer.renderContents({ sections: { 'cart-drawer': data } });

          // Re-attach the close button if it was removed
          if (closeButton && !cartDrawer.querySelector('.drawer__close')) {
            cartDrawer.prepend(closeButton);
            closeButton.addEventListener('click', () => cartDrawer.close());
          }
        }

        // Close drawer if cart is empty
        if (data.item_count === 0) cartDrawer?.close();

      } catch (err) {
        console.error('Error removing item:', err);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);
